export default __webpack_public_path__ + "static/media/927.eac32696.png";